export default class Colors {

    static readonly COLORS = ['#1A5276', '#ABB2B9', '#E74C3C', '#2ECC71', '#5DADE2', '#48C9B0', '#c3ee17', '#062bee', '#05f3ea']

}